declare var Shopify: { currency: { active: string } }

const PRICE_ON_APPLICATION_LABEL = 'Price on application'
const PRICE_ON_APPLICATION_TAG = 'price_poa'

const isPriceOnApplication = (amount: unknown, productTags: string[] = []) => {
  if (amount === null || amount === undefined || amount === '') {
    return false
  }

  const normalizedAmount = Number(amount)
  const normalizedTags = productTags.map((tag) => tag.toLowerCase())
  const hasPriceOnApplicationTag = normalizedTags.includes(PRICE_ON_APPLICATION_TAG)

  if (Number.isNaN(normalizedAmount)) {
    return false
  }

  return hasPriceOnApplicationTag && normalizedAmount === 0
}

const formatCentsToDollars = (cents: number) => {
  const currency = Shopify.currency.active || 'AUD'
  const dollars = cents / 100

  const formattedDollars = dollars.toLocaleString('en-AU', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  })

  return `${formattedDollars} ${currency}`
}

const formatMoney = (cents: number) => {
  return `${(cents / 100).toLocaleString()} ${Shopify.currency.active}`
}

const formatDollars = (dollars: number) => {
  return `${(dollars).toLocaleString()} ${Shopify.currency.active}`
}

export { PRICE_ON_APPLICATION_LABEL, isPriceOnApplication, formatCentsToDollars, formatMoney, formatDollars }